/**
 * **R18's sentence and where the preference lives** — the muted kinds named (`model/mutedSentence`,
 * or a surface's own wording of them), then the link to `/zadania/rodzaje`, the screen that sets
 * which kinds count (owner, 18 September 2026). The box around it is the surface's.
 *
 * Two nodes with a literal space between them: one joined string is the same words but a different
 * text run, and the browser shapes it a fraction differently.
 */

import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import mutedLink from '~/shared/ui/mutedLink.module.css';

export function MutedNote({ sentence }: { readonly sentence: string }) {
  const { t } = useTranslation();
  return (
    <>
      {sentence}{' '}
      <Link className={mutedLink.mutedLink} to="/zadania/rodzaje">
        {t('web:home.muted.link')}
      </Link>
    </>
  );
}
